import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
    buildConfiguration: 'akamai-dev',
    environmentFile: 'src/environments/environment.akamai_dev.ts',
    dashboardFilter: {
        dateRange: 4,
        unitOfTime: 'weeks',
    },
    JDE_API_URL: 'https://apidata.ecinsights.myrepsoft.com/api/',

    appName: 'cefero-doc',
    env: 'development',

    production: false,
    synfusionLicense:
        'Ngo9BigBOggjGyl/Vkd+XU9FcVRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3tSdkViWXxfdnVXT2NeU091Xg==',
    endpoints: {
        elasticSearchEndpoint: '',
    },

    apiRoot: 'https://dev-cloud-hub-api.cefero.com/api/',
    apAutomationApiRoot: 'https://dev-cloud-doc-api.cefero.com/api/',
    apiRootPython: 'https://dev-cloud-doc-api.cefero.com/',
    clientRoot: 'https://dev-cloud-app.myrepsoft.com/',
    clientId: 'cefero-client-production-akamai',

    stsAuthority: 'https://dev-cloud-auth.cefero.com/',
    scope: 'openid profile email role cefero-docupload-fullaccess',

    // Central configuration is authoritative for public OIDC settings.
    platformConfiguration: {
        enabled: true,
        required: true,
        requestTimeoutMs: 5000,
    },

    hubDataNotificationsUrl: 'https://apidata.ecinsights.myrepsoft.com/hub/data-notifications',
    hubUrl: 'https://apidata.ecinsights.myrepsoft.com/hub',
    loggerConfig: {
        level: NgxLoggerLevel.DEBUG,
        serverLogLevel: NgxLoggerLevel.WARN,
        serverLoggingUrl: 'https://dev-cloud-hub-api.cefero.com/api/admin/logs',
    },
};
